module.exports = {
  attach: function() {
    const $pdp = $('.product-detail');
      if ($pdp.is('*')) {
          const products = $('#gtm-pdp-products').attr('data-gtm-products');
          $('body').trigger('gtm:eec:productDetailsView', products);
      }
  }
}